var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 11.9997C6.29984 11.9997 5.98595 11.8691 5.72484 11.608C5.46373 11.3469 5.33317 11.033 5.33317 10.6663V2.66634C5.33317 2.29967 5.46373 1.98579 5.72484 1.72467C5.98595 1.46356 6.29984 1.33301 6.6665 1.33301H12.6665C13.0332 1.33301 13.3471 1.46356 13.6082 1.72467C13.8693 1.98579 13.9998 2.29967 13.9998 2.66634V10.6663C13.9998 11.033 13.8693 11.3469 13.6082 11.608C13.3471 11.8691 13.0332 11.9997 12.6665 11.9997H6.6665ZM6.6665 10.6663H12.6665V2.66634H6.6665V10.6663ZM3.99984 14.6663C3.63317 14.6663 3.31928 14.5358 3.05817 14.2747C2.79706 14.0136 2.6665 13.6997 2.6665 13.333V3.99967H3.99984V13.333H11.3332V14.6663H3.99984Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.383af9e80c07e17c12264f927634d4f2.svg";
export { ForwardRef as ReactComponent };